import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import * as api from '../../db/api.js'

/**
 * Página de redirect do Meta OAuth (Facebook Login for Business).
 *
 * Lê ?code=&state= da URL, manda autenticado pro backend que troca
 * code→long-lived token, persiste a meta_connection e retorna a lista de ad
 * accounts que o usuário pode vincular. Redireciona para o picker passando
 * connection_id + contas via location.state (não pela URL, evita logging em
 * CDN/proxy).
 *
 * Espelha GoogleAdsCallback (módulo isolado do Google).
 */
export default function MetaAdsCallback() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [error, setError] = useState('')
  const ran = useRef(false)

  useEffect(() => {
    // Guard contra StrictMode double-mount: o code do Meta é one-shot.
    if (ran.current) return
    ran.current = true

    const code = params.get('code')
    const state = params.get('state')
    const errParam = params.get('error') || params.get('error_message')

    if (errParam) {
      setError(`A Meta rejeitou o consent: ${errParam}`)
      return
    }
    if (!code || !state) {
      setError('Resposta da Meta incompleta (faltam code/state).')
      return
    }

    api
      .completeMetaAdsOAuth({ code, state })
      .then((data) => {
        // Facebook e Instagram (#320) não escolhem contas de anúncios: voltam para as Conexões.
        if (data.product && data.product !== 'ads') {
          navigate('/configuracoes/conexoes', { replace: true })
          return
        }
        navigate('/integrations/meta-ads/contas', {
          replace: true,
          state: {
            connectionId: data.connection_id,
            metaUserEmail: data.meta_user_email,
            accounts: data.available_accounts || [],
          },
        })
      })
      .catch((err) => {
        setError(err.message || 'Falha ao finalizar conexão com a Meta.')
      })
  }, [params, navigate])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'Inter, sans-serif',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        {error ? (
          <>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
              Não foi possível conectar
            </div>
            <div style={{ color: 'var(--ter, #6e6e73)', marginBottom: 24 }}>
              {error}
            </div>
            <button
              className="btn btn-black btn-sm"
              onClick={() => navigate('/perfil', { replace: true })}
            >
              Voltar para Perfil
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
              Finalizando conexão com Meta Ads…
            </div>
            <div style={{ color: 'var(--ter, #6e6e73)' }}>
              Estamos validando o consentimento e listando suas contas de anúncio.
            </div>
          </>
        )}
      </div>
    </div>
  )
}
